import {
    HOME_LIVE_API,
    HOME_REPLAY_API,
    HOME_BANNER_API,
    OPEN_COURSE_API,
    OPEN_COURSE_NEWS_API
} from '@constants/api';
import _axios from '@plugins/_axios';

/**
 * 获取首页直播预告
 */
export function getHomeLiveList() {
    return _axios.post(HOME_LIVE_API);
}

/**
 * 获取首页回放列表
 */
export function getHomeReplayList() {
    return _axios.post(HOME_REPLAY_API);
}

/**
 * 获取首页轮播图
 */
export function getHomeBannerList() {
    return _axios.post(HOME_BANNER_API);
}

/**
 * 获取公开课列表
 */
export function queryOpenCourseList({ subject_id, grade, page = 1, limit = 20 }) {
    return _axios.post(OPEN_COURSE_API, {
        subject_id,
        grade,
        page,
        limit
    });
}

/**
 * 获取公开课资讯
 */
export function queryOpenCourseNews() {
    return _axios.get(OPEN_COURSE_NEWS_API);
}
